import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'favorites',
      component: () => import('./views/Favorites.vue')
    },
    {
      path: '/stops',
      name: 'stops',
      component: () => import('./views/Stops.vue')
    },

    {
      path: '/stops/:origin',
      name: 'destinations',
      component: () => import('./views/Destinations.vue')
    },
    {
      path: '/stops/:from/:to',
      name: 'departures',
      component: () => import('./views/Departures.vue')
    },
    {
      path: '/maps',
      name: 'maps',
      component: () => import('./views/Maps.vue')
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('./views/Feedback.vue')
    },
  ]
})
